import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { Trans, useTranslation } from "react-i18next";

import { Arrange, Typography } from "@aviary";
import { useModularOnboardingModalData } from "@clinic/shared/hooks/useModularOnboardingModalData/useModularOnboardingModalData";
import { l } from "@clinic/shared/locales/i18n";
import { StoreSetupSteps } from "@clinic/shared/types/StoreSetupSteps";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { useCertifications } from "@shared/hooks/useCertifications/useCertifications";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { Link } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./CertificationWarningBar.styles";

const CertificationWarningBar = () => {
  const { t } = useTranslation();
  const { currentStep } = useModularOnboardingModalData();
  const storeSetupComplete = currentStep === StoreSetupSteps.COMPLETE;
  const { isCertified, certificationPending, loading } = useCertifications();
  const isRejected = storeSetupComplete && !certificationPending;

  const renderCertificationWarning = () => {
    if (isRejected) {
      return (
        <Trans i18nKey={l.sharedWarningBars.certification.cart.hasNoApprovedCertifications}>
          To place orders, you will need to
          <Link css={styles.link} to={emersonRoutes.account.credentials}>
            upload your professional credentials
          </Link>
        </Trans>
      );
    }

    if (certificationPending) {
      return t(l.sharedWarningBars.certification.cart.hasCertifications);
    }

    return (
      <Trans i18nKey={l.sharedWarningBars.certification.cart.notUploadedYet}>
        To place orders, you will need to
        <Link css={styles.link} to={emersonRoutes.onboarding}>
          complete account setup
        </Link>
      </Trans>
    );
  };

  if (isCertified || loading) {
    return null;
  }

  return (
    <Arrange spacing="xsmall" isWrapped={false} css={styles.wrapper}>
      <FontAwesomeIcon icon={faInfoCircle} />
      <Typography>{renderCertificationWarning()}</Typography>
    </Arrange>
  );
};

export { CertificationWarningBar };
